import { render } from "./accountPersonalDataAddress.vue?vue&type=template&id=822868a4"
import script from "./accountPersonalDataAddress.vue?vue&type=script&lang=js"
export * from "./accountPersonalDataAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__